import { gate } from 'hub-http/gates';
import { useHasAllGates } from './useHasAllGates';
const IARedesignGate = gate('CRM:Datasets:IndexRedesign');
export const useIsUngatedForIARedesign = (...secondaryGates) => {
  const hasAllGates = useHasAllGates();
  const isUngatedForIARedesign = hasAllGates(IARedesignGate, ...secondaryGates);
  return Boolean(isUngatedForIARedesign);
};